import React from 'react'
import { useTranslation } from 'react-i18next'
import './process.css'
import { FiSearch, FiLayout, FiCode, FiCheckCircle } from 'react-icons/fi'

const Process = () => {
  const { t } = useTranslation()

  const steps = [
    { icon: FiSearch, titleKey: 'step1Title', descKey: 'step1Desc' },
    { icon: FiLayout, titleKey: 'step2Title', descKey: 'step2Desc' },
    { icon: FiCode, titleKey: 'step3Title', descKey: 'step3Desc' },
    { icon: FiCheckCircle, titleKey: 'step4Title', descKey: 'step4Desc' },
  ]

  return (
    <section id="process" className="process-section">
      <div className="process-section__glow" />
      <div className="container">
        <div className="section__header">
          <span className="section__label">{t('process.subtitle')}</span>
          <h2 className="section__title">{t('process.title')}</h2>
        </div>

        <div className="process__track">
          {steps.map(({ icon: Icon, titleKey, descKey }, index) => (
            <article key={titleKey} className="process__step">
              <div className="process__circle-wrap">
                <div className="process__circle">
                  <Icon />
                </div>
                <span className="process__num">{String(index + 1).padStart(2, '0')}</span>
              </div>
              <h3>{t(`process.${titleKey}`)}</h3>
              <p>{t(`process.${descKey}`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Process
